import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ResetPreferences, DEFAULT_RESET_PREFERENCES } from '../models/reset-preferences.model';

@Injectable({
  providedIn: 'root'
})
export class ResetPreferencesService {
  private readonly PREFIX = 'reset_prefs_';
  private prefsChanged$ = new BehaviorSubject<{ moduleId: string; prefs: ResetPreferences } | null>(null);

  preferencesChanged$(): Observable<{ moduleId: string; prefs: ResetPreferences } | null> {
    return this.prefsChanged$.asObservable();
  }

  getPreferences(moduleId: string): ResetPreferences {
    const key = `${this.PREFIX}${moduleId}`;
    try {
      const stored = localStorage.getItem(key);
      if (stored) {
        return { ...DEFAULT_RESET_PREFERENCES, ...JSON.parse(stored) };
      }
    } catch (e) {
      console.warn(`Failed to parse reset preferences for ${moduleId}`, e);
    }
    return { ...DEFAULT_RESET_PREFERENCES };
  }

  savePreferences(moduleId: string, prefs: ResetPreferences): void {
    const key = `${this.PREFIX}${moduleId}`;
    try {
      localStorage.setItem(key, JSON.stringify(prefs));
      this.prefsChanged$.next({ moduleId, prefs });
    } catch (e) {
      console.error(`Failed to save reset preferences for ${moduleId}`, e);
    }
  }

  resetPreferences(moduleId: string): void {
    const key = `${this.PREFIX}${moduleId}`;
    try {
      localStorage.removeItem(key);
      this.prefsChanged$.next({ moduleId, prefs: { ...DEFAULT_RESET_PREFERENCES } });
    } catch (e) {
      console.error(`Failed to reset preferences for ${moduleId}`, e);
    }
  }

  clearAllPreferences(): void {
    try {
      const keys = Object.keys(localStorage).filter(k => k.startsWith(this.PREFIX));
      keys.forEach(k => localStorage.removeItem(k));
    } catch (e) {
      console.error('Failed to clear all reset preferences', e);
    }
  }
}
